import clsx from 'clsx';
import { DeviationDto } from 'src/generated/services/TFinancialApi';
import { TabIcon } from './TabIcon';

interface IButtonTabProps {
  data: DeviationDto;
  index: number;
  isActive: boolean;
  onChange(data: DeviationDto): void;
}

export const ButtonTab: React.FC<IButtonTabProps> = (props) => {
  const { data, index, onChange, isActive } = props;

  return (
    <button
      // key={`button-${index}-${isActive}`}
      type='button'
      className={clsx(
        'py-4 xl:py-8 pl-14 xl:pl-16 pr-6 xl:pr-8 flex items-center justify-start border rounded-full text-12 xl:text-14 font-bold overflow-hidden transition-all duration-700',
        isActive ? 'bg-primary text-white max-w-[2000px]' : 'border-primary bg-[#E0F3E6] text-primary max-w-[150px]'
      )}
      onClick={() => onChange(data)}
      // endIcon={<TabIcon status={data.status} />}
    >
      {/* <span>{item.id !== selectedDeviation?.id ? index + 1 : `Deviation ${index + 1} - ${item.name}`}</span> */}
      <div className='relative flex items-center gap-[6px]'>
        {/* Yellow circle indicator */}
        {data.isCurrentUserRequiredToFill && (
          <div
            className={clsx(
              'rounded-full transition-all duration-300 shrink-0',
              isActive ? 'w-10 h-10 bg-[#F79824] border-2 border-white' : 'w-10 h-10 bg-[#F79824]'
            )}
          />
        )}

        {/* Content Wrapper for Text/Number Swap */}
        <div className='flex items-center'>
          <span
            className={clsx('whitespace-nowrap overflow-hidden transition-all duration-300', isActive ? 'max-w-[2000px] opacity-100' : 'max-w-0 opacity-0')}
          >
            {`Deviation ${index + 1} - ${data.name === 'New Charge' ? 'Unknown Charge' : data.name}`}
          </span>
          <span
            className={clsx(
              'whitespace-nowrap overflow-hidden transition-all duration-300 text-14 xl:text-16',
              isActive ? 'max-w-0 opacity-0' : 'max-w-[100px] opacity-100'
            )}
          >
            {index + 1}
          </span>
        </div>

        <div className='shrink-0'>
          <TabIcon status={data.status} isActive={isActive} />
        </div>
      </div>
    </button>
  );
};
